<template>
  <div>
    <router-view></router-view>
    <b-modal
      id="noticePopup"
      :title="noticeInfo.title"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <NoticePopup :defaultInfo="noticeInfo" />
    </b-modal>
  </div>
</template>

<script>
import NoticePopup from "./components/NoticePopup.vue";

export default {
  name: "app",
  components: {
    NoticePopup,
  },
  data() {
    return {
      isNoticePopup: true,
      noticeInfo: {},
    };
  },
  mounted() {
    this.getNotice();
  },
  methods: {
    getNotice() {
      this.$http
        .post("/comn/getNotice", null)
        .then((res) => {
          if (res.data.resultyn == "Y") {
            if (res.data.data == null) return;

            this.noticeInfo = res.data.data;
            const dontShowPopupToday =
              localStorage.getItem("dontShowPopupToday");

            if (dontShowPopupToday != this.getTodayDate()) {
              this.$bvModal.show("noticePopup");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTodayDate() {
      const today = new Date();
      return `${today.getFullYear()}-${
        today.getMonth() + 1
      }-${today.getDate()}`;
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "./scss/style";
</style>
<style>
/* Import Font Awesome Icons Set
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  Import Simple Line Icons Set
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  Import Bootstrap Vue Styles
  @import '~bootstrap-vue/dist/bootstrap-vue.css';*/

@import "~flag-icon-css/css/flag-icon.min.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~simple-line-icons/css/simple-line-icons.css";
@import "~font-awesome/css/font-awesome.min.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~vue-tree-halower/dist/halower-tree.min.css";
@import "~ti-icons/css/themify-icons.css";
</style>



// WEBPACK FOOTER //
// src/App.vue